import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { take } from 'rxjs/operators';
import {
  DocumentBox,
  DocumentTypeEnum,
  UploadType,
} from '../../cta/models/document-box-interface';
import { UploadedPolicyDocument } from '../../cta/models/uploaded-policy-document.interface';
import { PolicyCreatorService } from '../../policy-creator/policy-creator.service';
import { OfferState } from '../../policy-creator/store/offer.state';
import { WarrantyOfferState } from '../../warranty-creator/store/warranty-offer.state';

@Component({
  selector: 'app-documents-upload-box',
  templateUrl: './documents-upload-box.component.html',
  styleUrls: ['./documents-upload-box.component.scss'],
})
export class DocumentsUploadBoxComponent implements OnInit {
  @Input() documentBox: DocumentBox;
  @Input() policyNo: string;
  @Input() isWarranty: boolean;
  @Output() documentUploaded: EventEmitter<void> = new EventEmitter();
  @Output() documentRemoved: EventEmitter<string> = new EventEmitter();

  constructor(
    private messageService: MessageService,
    private policyCreatorService: PolicyCreatorService,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.documentBox.documentBoxImg = this.getImageSrc();
  }

  getImageSrc(): string {
    switch (this.documentBox.documentBoxType) {
      case DocumentTypeEnum.invoice: {
        return this.isWarranty
          ? 'assets/icons/invoice-icon-green.svg'
          : 'assets/icons/invoice-icon.svg';
      }
      case DocumentTypeEnum.policy: {
        return this.isWarranty
          ? 'assets/icons/policy-icon-green.svg'
          : 'assets/icons/policy-icon.svg';
      }
      case DocumentTypeEnum.registryNo: {
        return this.isWarranty
          ? 'assets/icons/registryNo-icon-green.svg'
          : 'assets/icons/registryNo-icon.svg';
      }
    }
  }

  async handleUpload(event: { files: File[] }): Promise<void> {
    const policyId = this.store.selectSnapshot(OfferState.offerLocked)?.id;
    const warrantyPolicyId = this.store.selectSnapshot(
      WarrantyOfferState.warrantyOfferLocked,
    )?.id;

    if (policyId) {
      await this.prepareFiles(event.files, policyId);
      return;
    }

    if (warrantyPolicyId) {
      await this.prepareFiles(event.files, warrantyPolicyId);
    }
  }

  async prepareFiles(files: File[], policyId: number): Promise<any> {
    const payload = {
      uploadType: null,
      file: null,
      fileName: `${moment().format('YYYY-MM-DD[T]HH-mm-ss-SSSS')}_${
        files[0].name
      }`,
    };

    switch (this.documentBox.documentBoxType) {
      case DocumentTypeEnum.registryNo: {
        payload.uploadType = UploadType.policyTechnicalDocs;
        break;
      }
      case DocumentTypeEnum.policy: {
        payload.uploadType = UploadType.policyApplication;
        break;
      }
      case DocumentTypeEnum.invoice: {
        payload.uploadType = UploadType.policyInvoice;
      }
    }

    const fileReader = new FileReader();
    fileReader.readAsDataURL(files[0]);
    fileReader.onload = async () => {
      payload.file = fileReader.result;
      this.sendFiles(policyId, payload);
    };
  }

  sendFiles(policyId: number, payload) {
    this.policyCreatorService
      .uploadPolicyDocuments(policyId, payload)
      .pipe(take(1))
      .subscribe(
        () => {
          this.documentBox.uploaded = true;
          /* FIXME: below emitter triggers getting documents from iDefend,
             currently has missing endpoint and only one endpoint missingUploadTypes returns empty array */
          this.documentUploaded.emit();
        },
        (err: HttpErrorResponse) => {
          this.messageService.add({
            severity: 'error',
            summary: 'iDefend error',
            detail: err.error.message,
            life: 5000,
          });
        },
      );
  }

  deleteDocument(document: UploadedPolicyDocument): void {
    /*this.policyCreatorService
      .removePolicyDocument(0, document.id)
      .pipe(take(1))
      .subscribe(
        (res) => {
          this.documentRemoved.emit(this.policyNo);
          this.apkService.getPolicyUploadedDocs(this.policyNo);
        },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );*/
  }
}
